import { omit } from "lodash";
import { sunoCommsApi } from "../api-base";
import { CallCustomer } from "../types/call-customer.type";

export const callsEndpoints = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createCustomer: builder.mutation<CallCustomer, CallCustomer>({
      query: (body) => ({
        url: `/customers`,
        method: "POST",
        body
      }),
      invalidatesTags: ["CallCustomers"]
    }),
    updateCustomer: builder.mutation<
      Partial<Omit<CallCustomer, "id">> & Pick<CallCustomer, "id">,
      CallCustomer
    >({
      query: (data) => ({
        url: `/customers/${data.id}/`,
        method: "PATCH",
        body: omit(data, "id")
      }),
      invalidatesTags: ["CallCustomers"]
    }),
    getTwilioToken: builder.mutation<
      { jwt: string },
      {
        client_phone: string | undefined;
      }
    >({
      query: ({ client_phone }) => ({
        url: `/token/`,
        method: "POST",
        body: {
          phone: client_phone
        }
      }),
      invalidatesTags: ["CallLogs"]
    }),
    logCallEvent: builder.mutation<
      void,
      {
        event: string;
        direction: string;
        status: string;
        callSid: string;
        fromNumber: string;
        toNumber: string;
      }
    >({
      query: ({ event, direction, status, callSid, fromNumber, toNumber }) => ({
        url: `/calls/events/`,
        method: "POST",
        body: {
          event,
          direction,
          status,
          callSid,
          fromNumber,
          toNumber
        }
      }),
      invalidatesTags: ["CallLogs"]
    }),
    updateCallEvent: builder.mutation<
      void,
      {
        callSid: string;
        locationId?: string;
        contactId?: string;
        externalNumber?: string;
        internalNumber?: string;
        direction?: string;
        status?: string;
        duration?: string;
        recordingUrl?: string;
        transcription?: string;
        recordingSid?: string;
        event?: string;
      }
    >({
      query: ({ callSid, ...callData }) => ({
        url: `/calls/events/${callSid}/`,
        method: "PATCH",
        body: callData
      }),
      invalidatesTags: ["CallLogs"]
    })
  })
});

export const {
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useGetTwilioTokenMutation,
  useLogCallEventMutation,
  useUpdateCallEventMutation
} = callsEndpoints;

export { useCreateJwtTokenMutation } from "./auth.endpoints";
